import React from 'react';
/**
 * Slim utility bar above the main header (desktop only).
 */
export function TopBar() {
  return <div className="bg-gray-900 text-white text-xs py-1.5 px-4 hidden md:block" data-id="element-103">
      <div className="max-w-7xl mx-auto text-center" data-id="element-104">
        <p className="font-medium tracking-wide" data-id="element-105">
          Official U.S. Distributor for Daedo Electronic Scoring Equipment, Gen
          3 Gloves &amp; E-Foot Gear
        </p>
      </div>
    </div>;
}